import { useNavigate } from "react-router-dom";
import { formatDate } from "../../utility/Common";
import { RoutePaths } from "../../utility/RoutePaths";

const PaymentPendingVerification = ({ payment, classId, date }) => {
  const navigate = useNavigate();
  if (payment.length === 0) {
    return null;
  }

  var pay = payment[0];
  if (pay.Status === 1) {
    return (
      <div className="bg-yellow-600 text-white rounded-lg shadow-md p-6 mb-6 border-l-4">
        <div className="flex flex-col justify-between">
          <p className="text-white">
            Your payment record verification is pending. This will take 1-2
            business hours. If you have any questions, please contact support.
          </p>
          <p className="text-white mt-2">
            ඔබගේ ගෙවීම් වාර්තා මේ වනවිට සත්‍යාපනය කරමින් පවතී. මෙයට පැය 1-2ක්
            ගතවනු ඇත. ඔබට කිසියම් ප්‍රශ්නයක් ඇත්නම්, කරුණාකර සහාය අමතන්න.
          </p>
          <h2 className="text-lg font-bold text-white mt-4">
            Payment Date: {formatDate(pay.Date)}
          </h2>
        </div>
      </div>
    );
  } else if (pay.Status === 9) {
    return (
      <div className="bg-yellow-600 text-white rounded-lg shadow-md p-6 mb-6 border-l-4">
        <div className="flex flex-col justify-between">
          <p className="text-white">
            Your payment record verification is pending. This will take 1
            business hours. If you have any questions, please contact support.
          </p>
          <p className="text-white mt-2">
            ඔබගේ ගෙවීම් වාර්තා මේ වනවිට සත්‍යාපනය කරමින් පවතී. මෙයට පැය 1ක්
            ගතවනු ඇත. ඔබට කිසියම් ප්‍රශ්නයක් ඇත්නම්, කරුණාකර සහාය අමතන්න.
          </p>
          <h2 className="text-lg font-bold text-white mt-4">
            Payment Date: {formatDate(pay.Date)}
          </h2>
        </div>
      </div>
    );
  } else {
    return (
      <div className="bg-red-600 text-white rounded-lg shadow-md p-6 mb-6 border-l-4">
        <div className="flex flex-col justify-between">
          <p className="text-white">
            Your recent payment record rejected. If you have any questions, please
            contact support.
          </p>
          <p className="text-white mt-2">
            ඔබගේ ගෙවීම් වාර්තාව ප්‍රතික්ෂේප විය. ඔබට කිසියම් ප්‍රශ්නයක් ඇත්නම්,
            කරුණාකර සහාය අමතන්න.
          </p>
          <h2 className="text-lg font-bold text-white mt-4">
            Payment Date: {formatDate(pay.Date)}
          </h2>
        </div>
        <button
          onClick={() =>
            navigate(
              `${RoutePaths.STUDENT_CLASS_MONTH_PAYMENT_PAGE}?classId=${classId}&date=${date}`,
            )
          }
          className="px-6 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 font-medium transition-colors mt-4"
        >
          Pay Again
        </button>
      </div>
    );
  }
};

export default PaymentPendingVerification;
